import React from 'react';
import styles from './ComparisonBars.module.css';

const ComparisonBars = ({ items = [],  maxValue = 100, unit = '', suffix = '', rating = false  }) => {
    const formatValue = (val) => {
        const num = parseFloat(val) || 0;
        // If it's more than 100,000, assume it's the full amount and divide by 1M
        const scaled = num > 100000 ? num / 1000000 : num;
        return rating ? scaled : Math.round(scaled);
    };

    const formattedMax = formatValue(maxValue);

    return (
        <div className={styles['comparison-container-inner']}>
            <div className={styles['comparison-container']}>
                {items.map((item, index) => {
                    const percentage = Math.max(0, Math.min(100, (item.value / maxValue) * 100));
                    return (
                        <div key={index} className={styles['comparison-row']}>
                            <div className={styles['comparison-meta']}>
                                <span className={styles['comparison-name']}>{item.name}</span>
                                <span className={styles['comparison-value']}>
                                    {unit}{item.displayValue || formatValue(item.value)}{suffix}
                                </span>
                            </div>
                            <div className={styles['bar-bg']}>
                                <div 
                                    className={styles['bar-fill']} 
                                    style={{ 
                                        width: `${percentage}%`,
                                        background: item.color || 'var(--gold)'
                                    }} 
                                />
                            </div>
                        </div>
                    );
                })}
                <div className={styles['comparison-axis']}>
                    <span>0</span>
                    <span>{unit}{rating ? 3.3 : Math.floor(formattedMax * 0.33)}{suffix}</span>
                    <span>{unit}{rating ? 6.6 : Math.floor(formattedMax * 0.66)}{suffix}</span>
                    <span>{unit}{formattedMax}{suffix}</span>
                </div>
            </div>
        </div>
    );
};

export default ComparisonBars;
